export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";